/**
 * EK-A: Genelge Maddeleri Eşleştirme Tablosu (Bilgi ve İletişim Güvenliği Rehberi).
 * Madde metinleri i18n'de; bu dosya yalnızca yapı ve A/D eşleşmelerini tutar.
 * Eşleşmeler BIGDES_bg_rehber.pdf EK-A tablosundan (sayfa 211–214) doğrulanmıştır.
 */

/** @typedef {'A' | 'D'} CircularArticleRelation */

export const BIGDES_CIRCULAR_ARTICLE_MAPPING_COLUMNS = [
    { key: 'networkAndSystemSecurity', rehberRef: '3.1' },
    { key: 'applicationAndDataSecurity', rehberRef: '3.2' },
    { key: 'portableDeviceSecurity', rehberRef: '3.3' },
    { key: 'iotSecurity', rehberRef: '3.4' },
    { key: 'personnelSecurity', rehberRef: '3.5' },
    { key: 'physicalSecurity', rehberRef: '3.6' },
    { key: 'personalDataSecurity', rehberRef: '4.1' },
    { key: 'messagingSecurity', rehberRef: '4.2' },
    { key: 'cloudSecurity', rehberRef: '4.3' },
    { key: 'cryptoSecurity', rehberRef: '4.4' },
    { key: 'criticalInfrastructureSecurity', rehberRef: '4.5' },
    { key: 'newDevelopmentsAndSupply', rehberRef: '4.6' },
];

/**
 * @type {Array<{ articleNo: number, mappings: Record<string, CircularArticleRelation | null> }>}
 */
export const BIGDES_CIRCULAR_ARTICLE_MAPPING_ROWS = [
    {
        articleNo: 1,
        mappings: {
            networkAndSystemSecurity: 'A',
            applicationAndDataSecurity: 'A',
            portableDeviceSecurity: 'D',
            physicalSecurity: 'D',
            personalDataSecurity: 'A',
            cloudSecurity: 'A',
            cryptoSecurity: 'A',
        },
    },
    {
        articleNo: 2,
        mappings: {
            networkAndSystemSecurity: 'A',
            applicationAndDataSecurity: 'D',
            physicalSecurity: 'A',
            criticalInfrastructureSecurity: 'A',
        },
    },
    {
        articleNo: 3,
        mappings: {
            networkAndSystemSecurity: 'A',
            applicationAndDataSecurity: 'A',
            physicalSecurity: 'D',
            cloudSecurity: 'A',
        },
    },
    {
        articleNo: 4,
        mappings: {
            applicationAndDataSecurity: 'A',
            messagingSecurity: 'A',
            cryptoSecurity: 'D',
        },
    },
    {
        articleNo: 5,
        mappings: {
            personnelSecurity: 'A',
        },
    },
    {
        articleNo: 6,
        mappings: {
            messagingSecurity: 'A',
        },
    },
    {
        articleNo: 7,
        mappings: {
            physicalSecurity: 'A',
        },
    },
    {
        articleNo: 8,
        mappings: {
            iotSecurity: 'D',
            physicalSecurity: 'A',
        },
    },
    {
        articleNo: 9,
        mappings: {
            networkAndSystemSecurity: 'D',
            portableDeviceSecurity: 'A',
            iotSecurity: 'D',
            personnelSecurity: 'D',
        },
    },
    {
        articleNo: 10,
        mappings: {
            networkAndSystemSecurity: 'A',
            portableDeviceSecurity: 'D',
            cryptoSecurity: 'D',
        },
    },
    {
        articleNo: 11,
        mappings: {
            cryptoSecurity: 'A',
        },
    },
    {
        articleNo: 12,
        mappings: {
            applicationAndDataSecurity: 'A',
            personnelSecurity: 'D',
            newDevelopmentsAndSupply: 'D',
        },
    },
    {
        articleNo: 13,
        mappings: {
            networkAndSystemSecurity: 'D',
            applicationAndDataSecurity: 'A',
            messagingSecurity: 'D',
            newDevelopmentsAndSupply: 'D',
        },
    },
    {
        articleNo: 14,
        mappings: {
            networkAndSystemSecurity: 'A',
            criticalInfrastructureSecurity: 'A',
        },
    },
    {
        articleNo: 15,
        mappings: {
            networkAndSystemSecurity: 'A',
            applicationAndDataSecurity: 'A',
            personnelSecurity: 'A',
            physicalSecurity: 'A',
            personalDataSecurity: 'A',
        },
    },
    {
        articleNo: 16,
        mappings: {
            networkAndSystemSecurity: 'D',
            applicationAndDataSecurity: 'D',
            criticalInfrastructureSecurity: 'A',
        },
    },
    {
        articleNo: 17,
        mappings: {
            personnelSecurity: 'A',
        },
    },
    {
        articleNo: 18,
        mappings: {
            networkAndSystemSecurity: 'A',
            messagingSecurity: 'A',
            cloudSecurity: 'D',
        },
    },
    {
        articleNo: 19,
        mappings: {
            personnelSecurity: 'A',
            messagingSecurity: 'D',
        },
    },
    {
        articleNo: 20,
        mappings: {
            criticalInfrastructureSecurity: 'A',
        },
    },
    {
        articleNo: 21,
        mappings: {
            cryptoSecurity: 'A',
            criticalInfrastructureSecurity: 'A',
        },
    },
];
